import { healthPlanCategories } from 'constants/healthPlan';

import healthPlansStrings from 'modules/healthPlans/strings';
import useCustomNavigation from 'hooks/useCustomNavigation';
import {
  Container,
  ContainerTitle,
  Wrapper,
  Category,
  CategoryIcon,
  CategoryContent,
  Title,
  ArrowIcon,
} from './HealthPlansCategoriesComponent.style';

const HealthPlansCategoriesComponent = () => {
  const { handleNavigation } = useCustomNavigation();
  return (
    <Container>
      <ContainerTitle>{healthPlansStrings.categories.categories}</ContainerTitle>
      <Wrapper>
        {healthPlanCategories.map(catg => (
          <Category key={catg.name} onClick={() => handleNavigation(`/${catg.path}`, catg.name)}>
            <CategoryIcon icon={catg.icon} />
            <CategoryContent>
              <Title> {catg.name}</Title>
            </CategoryContent>
            <ArrowIcon />
          </Category>
        ))}
      </Wrapper>
    </Container>
  );
};
HealthPlansCategoriesComponent.propTypes = {};

HealthPlansCategoriesComponent.defaultProps = {};

export default HealthPlansCategoriesComponent;
